import groq from "groq";
import { Person, personFields } from "./person";
import type * as Schema from "./schema";

export type Author = Pick<Schema.Author, "slug" | "bio"> & {
  person?: Person;
};

export const authorFields: string = groq`
  person->{${personFields}},
  slug,
  bio
`;
